module.exports = __webpack_public_path__ + "static/logo-50baada919126ee4e93f059283934c9c.png";